import { useState, useEffect } from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAuth } from 'contexts/AuthContext';
import { useFeatures } from 'contexts/FeaturesContext';
import paymentDetailService from 'services/paymentDetailService';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { user } = useAuth();
  const { enabledFeatures, loading: featuresLoading } = useFeatures();
  const [pendingBankAccounts, setPendingBankAccounts] = useState(0);

  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (isAdmin) {
      const fetchStats = () => {
        paymentDetailService
          .getStatistics()
          .then((data) => setPendingBankAccounts((data.pending || 0) + (data.deactivation_requests || 0)))
          .catch(() => {});
      };
      fetchStats();

      window.addEventListener('bankAccountsUpdated', fetchStats);
      return () => window.removeEventListener('bankAccountsUpdated', fetchStats);
    }
  }, [isAdmin]);

  // Filter menu items based on user role and enabled features
  const filterMenuItems = (items) => {
    if (!user || featuresLoading) return [];

    return items
      .map((item) => ({ ...item })) // Create shallow copy to avoid mutation
      .filter((item) => {
        // Check role-based access
        if (item.roles && item.roles.length > 0) {
          if (!item.roles.includes(user.role)) {
            return false;
          }
        }

        // Check feature flags if defined
        if (item.requiredFeature && !enabledFeatures[item.requiredFeature]) {
          return false;
        }

        // Filter children if they exist
        if (item.children) {
          item.children = item.children
            .filter((child) => {
              // Check feature flags for child items
              if (child.requiredFeature && !enabledFeatures[child.requiredFeature]) {
                return false;
              }
              return true;
            })
            .map((child) => {
              // Inject pending badge on Vendors Bank Accounts menu item
              if (child.id === 'vendors-bank-accounts' && pendingBankAccounts > 0) {
                return { ...child, chip: { color: 'error', variant: 'filled', size: 'small', label: String(pendingBankAccounts) } };
              }
              return child;
            });

          // Don't show empty groups
          if (item.children.length === 0) {
            return false;
          }
        }

        return true;
      });
  };

  const filteredItems = filterMenuItems(menuItem.items);

  const navGroups = filteredItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
